/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, OnChanges } from '@angular/core';

import { IVehicleEcm, EFuelEfficiencyUnits } from '../../../core/models';

@Component({
  selector: 'fm-ecm-fuel-info-balloon-section',
  templateUrl: './ecm-fuel-info-balloon-section.component.html',
  styleUrls: ['./ecm-fuel-info-balloon-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EcmFuelInfoBalloonSectionComponent implements OnChanges {
  @Input()
  public vehicleEcm: IVehicleEcm;

  public isLowOnFuel: boolean;
  public remainingFuelPercentage: number;
  public EFuelEfficiencyUnits = EFuelEfficiencyUnits;

  private readonly LOW_FUEL_PERCENTAGE = 20;

  ngOnChanges(): void {
    this.isLowOnFuel = this.vehicleEcm.remainingFuelPercentage <= this.LOW_FUEL_PERCENTAGE;
    this.remainingFuelPercentage = this._roundPercentage(this.vehicleEcm.remainingFuelPercentage);
  }

  private _roundPercentage(remainingFuelPercentage: number): number {
    return this.isLowOnFuel ? Math.round(remainingFuelPercentage) : Math.round(remainingFuelPercentage / 5) * 5;
  }
}
